import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { SMALL_MOBILE_SIZE_BREAKPOINT } from 'consts'
import { TIMELINE_RULER_HEIGHT } from '../consts'

export const RulerContainer = styled.div`
  display: flex;
  width: min-content;
  min-width: 100%;
  height: ${TIMELINE_RULER_HEIGHT}px;
  position: relative;
  background-color: ${COLORS.white};
  padding-left: 20px;
  padding-right: 20px;
  border-top: 1px solid ${COLORS.borderColor};
  @media (max-width: ${SMALL_MOBILE_SIZE_BREAKPOINT}px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`
interface IRulerProps {
  $width: number
}

export const Ruler = styled.div<IRulerProps>`
  width: ${({ $width }) => $width}px;
  min-width: 100%;
  height: 2px;
  position: relative;
  overflow: hidden;
  height: 18px;
`

export const RulerTick = styled.div`
  position: absolute;
  top: 0;
  color: ${COLORS.secondaryDark};
  font-size: 10px;
  text-align: center;
  padding-top: 5px;
  &:before {
    content: '';
    width: 2px;
    height: 4px;
    background-color: ${COLORS.borderColor};
    position: absolute;
    top: 0;
    left: 0;
  }
  &:not(:first-child) {
    p {
      position: relative;
      transform: translateX(-50%);
    }
  }
`

export const RulerLine = styled.div`
  width: 1px;
  height: 8px;
  background-color: ${COLORS.borderColor};
  position: absolute;
  top: 0;
`
